import { render, staticRenderFns } from "./BusinessResponseTime.vue?vue&type=template&id=c3d76674&"
import script from "./BusinessResponseTime.vue?vue&type=script&lang=js&"
export * from "./BusinessResponseTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports